module.exports = __webpack_public_path__ + "static/img/2.85e4770.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/sp/2.png
// module id = mrL8
// module chunks = 0